module.exports = __webpack_public_path__ + "img/jfjsq.40984b9.png";